/**
 * Pomocnicze funkcje fokusu po akcji, ktora usuwa albo zmienia element z fokusem (usuniecie uwagi, uniewaznienie linku).
 *
 * Problem: przycisk, ktory wywolal akcje, znika z drzewa (albo traci przyciski), a okno potwierdzenia oddaje fokus
 * wlasnie jemu. Przegladarka zrzuca wtedy fokus na <body>, wiec uzytkownik klawiatury i czytnika ekranu zaczyna od gory
 * strony. Te funkcje wskazuja sensowne miejsce, w ktorym mozna go postawic.
 */

/**
 * Czy fokus zginal: aktywny jest <body>, element odpial sie od dokumentu albo siedzi w ukrytym oknie (zamkniete okno
 * dialogowe zostaje w DOM z atrybutem hidden, a przegladarka i tak z niego fokus zdejmuje). Gdy fokus stoi gdzie indziej,
 * uzytkownik zdazyl pojsc dalej i nie wolno mu go zabierac.
 */
export function czyFokusZginal(): boolean {
  const aktywny = document.activeElement;
  if (aktywny === null || aktywny === document.body || !aktywny.isConnected) return true;
  return aktywny.closest("[hidden]") !== null;
}

/**
 * Pierwszy przycisk w wierszach, od pozycji `start` w dol listy, a gdy tam nic nie ma, od `start - 1` w gore. Wiersz bez
 * przycisku (np. link juz uniewazniony) jest pomijany. Null, gdy zadnego przycisku nie ma.
 */
export function najblizszyPrzycisk(wiersze: ArrayLike<Element>, start: number): HTMLElement | null {
  const pierwszyPrzycisk = (wiersz: Element | undefined): HTMLElement | null =>
    wiersz?.querySelector<HTMLElement>("button:not([hidden])") ?? null;

  for (let i = Math.max(0, start); i < wiersze.length; i++) {
    const przycisk = pierwszyPrzycisk(wiersze[i]);
    if (przycisk) return przycisk;
  }
  for (let i = Math.min(start, wiersze.length) - 1; i >= 0; i--) {
    const przycisk = pierwszyPrzycisk(wiersze[i]);
    if (przycisk) return przycisk;
  }
  return null;
}
